<template>
<div id="app">
  <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>

    <v-flex xs12 sm12 md12>
        <v-card color="grey lighten-5" flat>
            <v-layout row wrap>

                <v-flex xs12 sm1 md1>

                    <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" v-if="Cari.Earchiveakayit!= true && Cari.Efaturakayit!=true && Cari.KagitFatura!=true " xs12 sm12 md12>
                        <v-toolbar flat="" size="120px" dark color="green">
                            <v-toolbar-title> {{ $t('Select-Current-Account') }} </v-toolbar-title>
                        </v-toolbar>
                    </v-flex>

                    <v-card flat v-if="Cari.Earchiveakayit!= true && Cari.Efaturakayit!=true && Cari.KagitFatura!=true " v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" color="info" height="100%" class="white--text">
                        <v-card-actions>
                            <v-flex xs12 sm12 md12>
                                <v-layout align-start="" justify-center="" fill height>
                                    <div class="rotate">
                                        <div class="icorta">
                                            <span class="subheading text-no-wrap font-weight-bold white--text mb-2">{{ $t('Select-Current') }}</span>
                                        </div>
                                    </div>
                                </v-layout>
                            </v-flex>
                        </v-card-actions>
                    </v-card>

                    <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" v-if="this.Cari.Earchiveakayit" xs12 sm12 md12>
                        <v-toolbar flat="" size="120px" dark color="green">
                            <v-toolbar-title> E-Arşiv </v-toolbar-title>
                        </v-toolbar>
                    </v-flex>

                    <v-card flat v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" v-if="this.Cari.Earchiveakayit" color="green" height="100%" class="white--text">
                        <v-card-actions>
                            <v-flex xs12 sm12 md12>
                                <v-layout align-start="" justify-center="" fill height>
                                    <div class="rotate">
                                        <div class="icorta">
                                            <span class="subheading text-no-wrap font-weight-bold white--text mb-2">E-Arşiv</span>
                                        </div>
                                    </div>
                                </v-layout>
                            </v-flex>
                        </v-card-actions>
                    </v-card>

                    <v-flex xs12 sm12 md12 v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" v-if="Cari.Efaturakayit">
                        <v-toolbar flat="" size="120px" dark color="red">
                            <v-toolbar-title> {{ $t('E-Invoice') }} </v-toolbar-title>
                        </v-toolbar>
                    </v-flex>

                    <v-card flat v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" v-if="Cari.Efaturakayit" color="red" height="100%" class="white--text">
                        <v-card-actions>
                            <v-flex xs12 sm12 md12>
                                <v-layout align-start="" justify-center="" fill height>
                                    <div class="rotate">
                                        <div class="icorta">

                                            <span class="subheading text-no-wrap font-weight-bold white--text mb-2">{{ $t('E-Invoice') }}</span>
                                        </div>
                                    </div>
                                </v-layout>
                            </v-flex>
                        </v-card-actions>
                    </v-card>

                    <v-card flat v-if="this.Cari.KagitFatura" color="pink" height="100%" class="white--text">
                        <v-card-actions>
                            <v-flex xs12 sm12 md12>
                                <v-layout align-start="" justify-center="" fill height>
                                    <div class="rotate">
                                        <div class="icorta">

                                            <span class="subheading text-no-wrap font-weight-bold white--text mb-2">{{ $t('Hard-Copy-Invoice') }} </span>
                                        </div>
                                    </div>
                                </v-layout>
                            </v-flex>
                        </v-card-actions>
                    </v-card>

                </v-flex>

                <v-flex xs11 sm11 md11>
                    <v-card flat class="white--text">
                        <v-layout row wrap pa-2>
                            <v-flex xs10 sm10 md10>
                                <v-autocomplete  class="carihesapsearch" maxlength="100" id="cariComp" @keyup.delete="deleteCariComp()" :disabled="aktifmi" @click="selectCariComp()" :autofocus="autofocuss" @blur="focuslost(val)" :items="statecari" :rules="rule" color="blue-grey lighten-2" :label="$t('Accound-Code')" v-model="val" hide-details clearable append-outer-icon="search" :loading="loading" item-text="autoText" item-value="id" :search-input.sync="search1">
                                   <template v-slot:prepend>
                                      <v-icon color="info" @click="openSearhDialog()">search</v-icon>
                                    </template>
                                   
                                   <template v-slot:selection="data">
                                        {{data.item.id}} -
                                        <div class="teksatir" v-if="data.item.unvan2 && data.item.unvan2.length > 0 &&  1 > data.item.unvan1.length">
                                            {{data.item.unvan2}}
                                        </div>
                                        <div class="teksatir" v-if="data.item.unvan1 && data.item.unvan1.length > 0">
                                            {{data.item.unvan1}}
                                        </div>
                                    </template>
                                    <template v-slot:item="data">
                                        <v-layout row wrap pa-1 style="height:inherit">
                                            <v-flex xs10 sm10 md4>
                                                <v-layout row wrap style="height:auto">
                                                    <v-flex xs10 sm10 md12>
                                                        <span class="subheading font-weight-medium"> {{ $t('Code') }}</span>
                                                    </v-flex>
                                                    <v-flex xs10 sm10 md12>
                                                        <span class="body-1" v-html="data.item.id">

                                                        </span>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs10 sm10 md5>
                                                <v-layout row wrap>
                                                    <v-flex xs10 sm10 md12>
                                                        <span class=" subheading font-weight-medium"> {{ $t('Title_label') }}  </span>
                                                    </v-flex>
                                                    <v-flex xs10 sm10 md12>
                                                        <span class="body-1" v-html="data.item.unvan1">
                                                        </span>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs10 sm10 md3>
                                                <v-layout row wrap>
                                                    <v-flex xs10 sm10 md12>
                                                        <span class="subheading font-weight-medium">  {{ $t('Title_label') }} 2</span>
                                                    </v-flex>
                                                    <v-flex xs10 sm10 md12>
                                                        <span class="body-1" v-html="data.item.unvan2">
                                                        </span>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </template>
                                </v-autocomplete>
                               
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                                <v-layout align-center="" fill-height="">
                                    <v-btn fab small :disabled="aktifmi" @click="dialogCariOpen()" color="info" icon>
                                        <v-icon>add_box</v-icon>
                                    </v-btn>
                                </v-layout>
                            </v-flex>
                            <v-layout row wrap>
                                <v-flex xs10 sm10 md10>
                                    
                            <v-flex xs12 sm12 md12>
                                <span class="body-1 font-weight-bold grey--text mb-2">
                                    {{$t('Title_label')}}/{{$t('Code')}}: {{unvan}} - {{codeSet}} </span>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <span class="body-1 font-weight grey--text mb-2"> {{ $t('Address_label') }}  :
                                    {{ Cari.EFaturaBilgi.Adres1}} </span>

                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <span class="body-1 font-weight grey--text mb-2">{{this.$t('VKN-TC')}} :
                                    {{Cari.EFaturaBilgi.TcKimlikNo}} /
                                    {{Cari.EFaturaBilgi.VergiDairesi}}-{{Cari.EFaturaBilgi.VergiNo}}</span>

                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <span class="body-1 font-weight grey--text mb-2"> {{ $t('Credit-Limit') }} :
                                    {{kredilimiti | moneyformat}}{{getparabirimi()}} </span>

                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <span class="body-1 font-weight grey--text mb-2">{{$t('Balance')}}:
                                    {{bakiye | bakiyekontrol}}{{getparabirimi()}} </span>

                            </v-flex>
                            </v-flex>
                                <v-flex xs2 sm2 md2 v-if="warningNote != null">
                                         <v-layout align-center="" fill-height="">
                                    <v-btn fab small @click.native="dialogWarningNote = true" color="info" icon>
                                        <v-icon color="white">info</v-icon>
                                    </v-btn>
                                </v-layout>
                                </v-flex>
                            </v-layout>

                        </v-layout>
                    </v-card>
                </v-flex>

            </v-layout>
        </v-card>
    </v-flex>
    <v-layout row justify-center>
        <v-dialog v-model="dialogWarningNote" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{ $t('Warning') }}</v-card-title>
                <v-card-text class="body-2">
                    <blockquote> 
                        {{ warningNote }}
                    </blockquote>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.native="dialogWarningNote = false">{{ $t('Close') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>

    <v-dialog v-model="dialogyenicari" scrollable="" persistent="" max-width="400px">
        <v-card color="grey lighten-5">
            <v-card-title> {{ $t('Add-New-Current-Card') }} </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row="" wrap="">
                    <v-flex pa-1 xs12 sm6 md12>
                        <v-card class="white--text">
                            <v-card color="grey lighten-5" flat="">
                                <v-card-actions>
                                    <v-layout justify-space-between column>
                                        <v-form ref="formcariyegore" v-model="valid" lazy-validation>

                                            <v-select :items="musteritipi" hide-details="" v-model="Current.CustomerType" item-text="text" item-value="value" clearable :label="$t('Customertype_label')">
                                            </v-select>
<v-select :items="caritipi" hide-details="" v-model="Current.AliciSatici" item-text="text" item-value="value" clearable :label="$t('Current-Type')">
                                                    </v-select>
                                            <v-text-field :rules="[v => !!v || $t('This-area-mandatory')]" :label="$t('Currentcode_label')" append-icon="history" @click:append="getLastCode()" maxlength="15" v-model="Current.Code" hide-details="">
                                            </v-text-field>
                                            <v-text-field hide-details="" :rules="[v => !!v || $t('This-area-mandatory')]" :label="$t('Title_label')" maxlength="100" v-model="Current.Title">
                                            </v-text-field>
                                            <v-text-field hide-details="" :label="$t('Phonenumber_label')" maxlength="15" v-model="Current.Phone1"></v-text-field>
                                            <v-text-field hide-details="" :label="$t('Email_label')" v-model="Current.Email"></v-text-field>
                                            <div v-if="PB=='TRY'">
                                                <muhasebekoducomp :etiket="$t('Accounting-Code')"  maxlength="25" v-model="Current.AccountingCode"></muhasebekoducomp>
                                              </div>

                                          
                                            
                                               <masrafmerkezicomp  v-model="Current.ExpenseCenter"> </masrafmerkezicomp>
                                             <v-autocomplete hide-details clearable :items="hesapgurubu" v-model="Current.AccountGroup" label="Hesap Gurubu" item-text="Title" item-value="Kod" max-height="400">
                                             </v-autocomplete>
                                             <cariaracomp v-bind:etiket="$t('Main-Account')"  v-model="Current.MainAccount"></cariaracomp>

                                        </v-form>

                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>

                    <v-flex pa-1 xs12 sm6 md12>
                        <v-card class="white--text">
                            <v-card color="grey lighten-5" flat="">
                                <v-card-actions>
                                    <v-layout justify-space-between column>
                                        <v-card flat="" color="#9E9E9E">
                                            <v-card-title>
                                                <span class="subheading white--text font-weight-medium ">{{ $t('Billingaddressinformation_headers') }}  </span>
                                            </v-card-title>
                                        </v-card>
                                        <v-text-field hide-details="" :label="$t('Taxcenter_label')" v-model="Current.Invoice.TaxOffice">
                                        </v-text-field>

                                        <v-layout align="center">
                                            <v-flex xs8 sm8 md8>
                                                <v-form ref="vergino" v-model="valid2" lazy-validation>

                                                    <v-text-field hide-details="" :rules="[v => !!v || $t('Mandatory-section')]" :label="$t('Taxnumber_label')" v-model="Current.Invoice.TaxNumber"></v-text-field>
                                                </v-form>

                                            </v-flex>
                                            <v-flex xs4 sm4 md4>
                                                <v-layout align="center" fill-height column justify-end>

                                                    <v-btn small flat @click="mukellefSorgula()" color="info"> {{ $t('Inquire-Liables') }} </v-btn>
                                                </v-layout>
                                            </v-flex>

                                        </v-layout>

                                        <v-flex v-if="vkngorunum" xs12 sm12 md12>
                                            <span class="caption font-weight grey--text ">
                                                {{ $t('Post-Label') }} : {{ this.Current.PostCodeLabel}} </span>
                                        </v-flex>
                                        <v-flex v-if="vkngorunum" xs12 sm12 md12>
                                            <span v-if="efaturamukellefi" class="caption font-weight grey--text ">
                                                {{$t('E-invoicetypeamenable_label')}} <v-icon small>check</v-icon> </span>
                                        </v-flex>
                                        <v-flex v-if="vkngorunum" xs12 sm12 md12>
                                            <span v-if="!efaturamukellefi" class="caption font-weight grey--text ">
                                                {{ $t('Is-not-E-Invoice-Liable') }} <v-icon small>clear</v-icon> </span>
                                        </v-flex>
                                        <v-flex v-if="!vkngorunum" xs12 sm12 md12>
                                            <span class="caption font-weight grey--text ">
                                                {{ vknmesaj}} </span>
                                        </v-flex>

                                        <!--
                      <v-text-field hide-details="" :label="$t('Taxnumber_label')" v-model="Current.Invoice.TaxNumber">
                      </v-text-field> -->
                                        <v-text-field hide-details="" :label="$t('Postcode_label')" v-model="Current.Invoice.PostCode">
                                        </v-text-field>
                                        <v-text-field hide-details="" :label="$t('Country_label')" v-model="Current.Invoice.Country"></v-text-field>
                                        <v-text-field hide-details="" :label="$t('Province_label')" v-model="Current.Invoice.Province"></v-text-field>
                                        <v-textarea hide-details="" no-resize v-model="Current.Invoice.Address" :label="$t('Address_label')">
                                        </v-textarea>
                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>

                    </v-flex>

                    <v-flex pa-1 xs12 sm12 md12>
                        <v-card class="white--text">
                            <v-card color="grey lighten-5" flat="">
                                <v-card-actions>
                                    <v-layout justify-space-between column>

                                        <v-card flat="" color="#9E9E9E">
                                            <v-card-title>
                                                <span class="subheading white--text font-weight-medium ">{{ $t('Foridentity_header') }} </span>
                                            </v-card-title>
                                        </v-card>
                                        <v-text-field hide-details="" :label="$t('Identitynumber_label')" value="" mask="###########" v-model="Current.Invoice.IdentityNumber"></v-text-field>
                                        <v-text-field hide-details="" :label="$t('Name_label')" maxlength="50" v-model="Current.Invoice.PerFirstName" required>
                                        </v-text-field>
                                        <v-text-field hide-details="" :label="$t('Surname_label')" maxlength="50" v-model="Current.Invoice.PerFamilyName" required>
                                        </v-text-field>
                                        <v-text-field hide-details="" :label="$t('Title_label')" maxlength="50" v-model="Current.Invoice.PerTitle" required>
                                        </v-text-field>
                                        <v-text-field hide-details="" :label="$t('Othername_label')" maxlength="50" v-model="Current.Invoice.PerMiddleName" required>
                                        </v-text-field>
                                        <v-text-field hide-details="" :label="$t('Suffixname_label')" maxlength="50" v-model="Current.Invoice.PerNameSuffix" required>
                                        </v-text-field>
                                        <v-text-field hide-details="" label="Passport Number" maxlength="9" v-model="Current.Invoice.PassportNumber" required>
                                        </v-text-field>
                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>

                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialogyenicari=false">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat v-on:click="counter += 1">{{$t("save_button")}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="900">
        <v-card>
            <v-card-title class="headline">{{$t('Search-Current')}}</v-card-title>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12 sm8 md12>
                      <v-flex xs12 sm8 md6>
                        <v-text-field
                        v-model="limitSearchText"
                            :label="this.$t('Accounting-Code')"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm8 md6>
                        <v-text-field
                        v-model="Filters.TitleOne"
                            :label="this.$t('Title1')"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm8 md6>
                        <v-text-field
                        v-model="Filters.TitleTwo"
                        :label="this.$t('Title2')"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm8 md6>
                        <v-select hide-details v-model="Filters.AccountType" :items="musteritipi"
                                :label="this.$t('Account-Type')" item-text="text" item-value="value">
                            </v-select>
                    </v-flex>
                      <v-flex xs12 sm8 md6>
                        <v-select hide-details v-model="Filters.AliciSatici" :items="caritipi"
                                :label="this.$t('Current-Type')" item-text="text" item-value="value">
                            </v-select>
                    </v-flex>
                    <v-flex xs12 sm8 md6>
                        <v-text-field
                        v-model="Filters.TcNo"
                        :label="this.$t('IDNumber-or-TaxNumber')"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md12 pt-2>
                        <v-btn block color="primary" dark @click="cariGetirSearchDialog()">{{this.$t('Search')}}</v-btn>
                    </v-flex>
                    </v-flex>
                    <v-flex xs12 sm12 md12 pt-2>
                  <v-flex xs12 sm12 md12>
                  <v-data-table
                    :headers="headers"
                    :items="dialogItems"
                    hide-actions
                    :loading="loadingResult"
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <tr @click="setItem(props.item)">
                        <td class="text-xs-left">{{ props.item.id }}</td>
                        <td class="text-xs-left">{{ props.item.unvan1 }}</td>
                        <td class="text-xs-left">{{ props.item.unvan2 }}</td>
                        <td class="text-xs-left">{{ props.item.tckimlikno }}</td>
                        <td class="text-xs-left">{{ props.item.vergino }}</td>
                        <td class="text-xs-left">{{ props.item.uyari }}</td>
                        <td class="text-xs-left">{{ props.item.yetkili }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                    </v-flex>
                </v-layout>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="closeDialog()">{{ $t('Close') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-layout>


</div>
</template>

<script>
import auth from "../../../api/auth";
import tool from "../coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";
import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue";
import muhasebekoducomp from "@/components/app/customcomp/muhasebekoducomp.vue";
import cariaracomp from '@/components/app/customcomp/cariaracomp'
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

export default {
  //props: ["value", "tabdeger", "statecariyedek", "autofocuss", "aktifmi", "Coper"],
  props: {
    value: {
      type: String,
    },
    Coper: {
      type: Boolean,
      default: false,
    },
    statecariyedek: {
      type: Array,
    },
    zorunlumu: {
      type: Boolean,
      default: false,
    },
    aktifmi: {
      type: Boolean,
      default: false,
    },
    autofocuss: {
      type: Boolean,
      default: false,
    },
    tabdeger: {},
  },
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  components: {
    masrafmerkezicomp,
    muhasebekoducomp,
    cariaracomp,
    snackbarcomp
  },
  beforeMount: beforeMount,
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
  methods: {
    setItem(val){
    this.val = val.id;
    this.dialog = false;
    this.searchLimit = false;
    },
    closeDialog(){
     this.searchLimit = false;
     this.dialog = false;
    },
    openSearhDialog(){
     // Bilesen kilitliyken (aktifmi) arama dialogundan baska cari secilemesin.
     if (this.aktifmi) { return; }
     this.dialogItems = [];
     this.dialog  = true;
     this.searchLimit = true;
    },
    dialogCariOpen() {
      // Bilesen kilitliyken (aktifmi) yeni cari eklenemesin: kayit secili cariyi degistiriyor.
      if (this.aktifmi) { return; }
      this.dialogyenicari = true;
      this.hesapGrubuGetir();
    },
    getLastCode() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var current = {
        CompanyCode: credentials.SirketKodu,
        Text: this.Current.Code,
      };

      this.$http
        .post(auth.API_URL + "api/Helpers/GetLastCurrent", current, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.Current.Code = response.body;
          },
          () => {
            this.text1 = "Kod getirilemedi, tekrar deneyiniz.";
            this.snackbar = true;
          }
        );
    },
    selectCariComp() {
      document.getElementById("cariComp").select();
    },
    deleteCariComp(a) {
      this.val = null;
      document.getElementById("cariComp").click();
    },
    getparabirimi() {
      return helpers.getparabirimi();
    },
    focuslost(a) {
      if (a == null) {
        this.val = null;
      }
    },
    mukellefSorgula() {
      if (this.$refs.vergino.validate()) {
        if (this.Current.Invoice.TaxNumber.length == 10) {
          var prm = {
            VKN: this.Current.Invoice.TaxNumber, //9240492097
          };
          tool.api_post(this, "EFatura/VKN_Sorgula", prm).then(
            (response) => {
              this.postaitems = [];
              if (response.body.length > 0) {
                this.efaturamukellefi = true;
                this.Current.PostCodeLabel = response.body[0].alias;
                this.vkngorunum = true;
              } else {
                this.efaturamukellefi = false;
                this.vknmesaj = this.$t('No-liable-found')
                this.vkngorunum = false;
              }
            },
            (response) => {
              this.status = tool.responseToStatus(response);
            }
          );
        } else {
          this.vknmesaj = this.$t('Please-Enter-Your-Digit-Taxation-Number');
          this.vkngorunum = false;
        }
      } else {
        this.vknmesaj = this.$t('Please-Enter-Your-Digit-Taxation-Number')
        this.vkngorunum = false;
      }
    },
    yenicarikaydet() {
      if (this.counter == 1) {

      if (this.$refs.formcariyegore.validate()) {
        var credentials = JSON.parse(
          window.localStorage.getItem("credentials")
        );

        if (this.efaturamukellefi == true) {
          this.Current.EInvoiceCustomer = "1";
        } else {
          this.Current.EInvoiceCustomer = "0";
        }

        if (this.Coper == true) {
          this.Current.CompanyCode = credentials.CoperSirketNo;
          this.Current.Coper = true;
        } else {
          this.Current.CompanyCode = credentials.SirketKodu;
          this.Current.Coper = false;
        }

        var current = this.Current;

        this.$http
          .post(auth.API_URL + "api/Current/New", current, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          })
          .then(
            (response) => {
              if (response.body.Status === true) {
                var seciliitems = [
                  {
                    unvan1: this.Current.Title,
                    id: this.Current.Code,
                    unvan2: this.Current.Title2,
                  },
                ];

                this.statecari = seciliitems;
                this.val = this.Current.Code;

                 this.text1 = this.$t(response.body.ResponseMessage);
                this.snackbar = true;

                this.Current.Code = null;
                this.Current.Title = null;
                this.Current.Phone1 = null;
                this.Current.AccountingCode = null;
                this.Current.Email = null;
                this.Current.Authorized = null;
                this.Current.CustomerType = null;
                this.Current.EInvoiceType = null;
                this.Current.EArchiveSendType = true;
                this.Current.Invoice.Address = null;
                this.Current.Invoice.PostCode = null;
                this.Current.Invoice.Province = null;
                this.Current.Invoice.Country = null;
                this.Current.Invoice.TaxNumber = null;
                this.Current.Invoice.TaxOffice = null;
                this.Current.Invoice.IdentityNumber = null;
                this.Current.Invoice.PerFirstName = null;
                this.Current.Invoice.PerFamilyName = null;
                this.Current.Invoice.PerTitle = null;
                this.Current.Invoice.PerMiddleName = null;
                this.Current.Invoice.PerNameSuffix = null;
                this.Current.Invoice.CustomerPersonelNoInvoice = null;
                this.Current.Invoice.DeliveryAddress = null;
                this.Current.Invoice.DeliveryName = null;
                this.cariislemler();
                 this.counter = 0
                this.dialogyenicari = false;
              } else if (response.body.Status === false) {
                 this.text1 = this.$t(response.body.ResponseMessage);
                this.snackbar = true;
                 this.counter = 0
              }
            },
            (response) => {
              if (response.status === 0) {
                 this.text1 = this.$t(response.body.ResponseMessage);
                this.snackbar = true;
                 this.counter = 0
              } else {
                 
                let data ={
                response: response,
                request: current,
                api:'Current/New',
                type:2,
                message: response.body.ExceptionMessage
                };
                this.$refs.showMessage.open(data);
                 this.counter = 0
              }
            }
          );
      } else {
        this.text1 = this.$t('Please-fill-required-fields');
        this.snackbar = true;
         this.counter = 0
      }
      }
    },
    cariislemler() {

      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {};

      if (this.Coper == true) {
        params = {
          Code: this.val,
          CompanyCode: credentials.CoperSirketNo,
          Coper: true,
        };
      } else {
        params = {
          Code: this.val,
          CompanyCode: credentials.SirketKodu,
          Coper: false,
        };
      }

      this.$http
        .post(auth.API_URL + "api/Current/Get", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            var yeniitems = {
              id: response.body.Code,
              unvan1: response.body.Title,
              unvan2: response.body.Title2,
              autoText:
                response.body.Title +
                "-" +
                response.body.Title2 +
                "-" +
                response.body.Code,
            };
            this.statecari.push(yeniitems);
            this.$emit("sendCurrentInfo", response.body);
            this.unvan = response.body.Title;
            this.codeSet = response.body.Code;
            this.warningNote = response.body.InfoNote + " " + response.body.WarningNote;
  
            if(this.warningNote.trim().length == 0){
              this.warningNote = null;
            }

            if (
              response.body.CreditLimit == null ||
              response.body.CreditLimit == ""
            ) {
              this.kredilimiti = parseFloat(0);
            } else {
              this.kredilimiti = parseFloat(response.body.CreditLimit);
            }

            if (response.body.Balance == null || response.body.Balance == "") {
              this.bakiye = parseFloat(0);
            } else {
              this.bakiye = parseFloat(response.body.Balance);
            }

            this.Cari.EFaturaBilgi.Unvani = response.body.Title;
            this.Cari.EFaturaBilgi.Adres1 = response.body.Invoice.Address;
            this.Cari.EFaturaBilgi.IlçeSehir = response.body.Invoice.Province;
            this.Cari.EFaturaBilgi.Email = response.body.Email;
            this.Cari.EFaturaBilgi.VergiDairesi =
              response.body.Invoice.TaxOffice;
            this.Cari.EFaturaBilgi.VergiNo = response.body.Invoice.TaxNumber;
            this.Cari.EFaturaBilgi.TcKimlikNo =
              response.body.Invoice.IdentityNumber;
            this.Cari.EFaturaBilgi.Adi = response.body.Invoice.PerFirstName;
            this.Cari.EFaturaBilgi.Soyadi = response.body.Invoice.PerFamilyName;
            this.Cari.EFaturaBilgi.TUnvani = response.body.Invoice.PerTitle;
            this.Cari.EFaturaBilgi.DigerAdi =
              response.body.Invoice.PerMiddleName;
            this.Cari.EFaturaBilgi.OnAdiEki =
              response.body.Invoice.PerNameSuffix;
            this.efaturatipigecici = String(response.body.EInvoiceType);

            //ana sirket e faturacı değilse kağıt fatura
            if (credentials.EFatura != "1") {
              this.Cari.Efaturakayit = false;
              this.Cari.Earchiveakayit = false;
              this.Cari.KagitFatura = true;
            }

            if (
              credentials.EFatura == "1" &&
              response.body.EInvoiceCustomer == "1"
            ) {
              // ana sirket efatura cari efatura o zaman efaturacı
              this.Cari.Efaturakayit = true;
              this.Cari.Earchiveakayit = false;
              this.Cari.KagitFatura = false;
            }

            if (
              credentials.EFatura == "1" &&
              response.body.EInvoiceCustomer == "0"
            ) {
              if (credentials.EArsiv == "1") {
                //anasirket efatura cari earsiv  o zaman earşivci
                this.Cari.Earchiveakayit = true;
                this.Cari.Efaturakayit = false;
                this.Cari.KagitFatura = false;
              } else {
                this.Cari.Earchiveakayit = false;
                this.Cari.Efaturakayit = false;
                this.Cari.KagitFatura = true;
              }
            }

            // GiB seri listesi burada cekilmiyor: sonucu (gibseri/gibserigoster) bu bilesende hic
            // kullanilmiyordu, her cari getirmede bosuna istek gidiyordu. Seriyi gosteren ekran
            // listeyi kendisi getiriyor (orn. fatura/faturakalemleri.vue cariBilgisiGeldi).
          },
          (response) => {
            if (response.status === 0) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
            } else {
              this.text1 = response.statusText;
              this.snackbar = true;
            }
          }
        );
    },
    hesapGrubuGetir() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CompanyCode: credentials.SirketKodu,
      };
      this.$http
        .post(auth.API_URL + "api/Definitions/CurrentGroupList", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.hesapgurubu = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            }
          }
        );
    },
   
    carigetir,
    cariGetirSearchDialog:cariGetirSearchDialog
  },
  data() {
    return {
      PB:'TRY',
      searchLimit:false,
      headers:[
          {
              text:this.$t('Code')
          },
          {
              text:this.$t('Title1')
          },
          {
              text:this.$t('Title2')
          },
          {
              text:this.$t('IDNumber')
          },
          {
              text:this.$t('TaxNumber')
          },
          {
              text:this.$t('Warning')
          },
          {
              text:'Yetkili'
          },
      ],
        caritipi: [{
                    text: this.$t('Customer-and-Supplier'),
                    value: 0
                },
                {
                    text: this.$t('Supplier'),
                    value: 1
                }, {
                    text: this.$t('Customer'),
                    value: 2
                },
            ],
      musteritipi: [{
                    text: this.$t('All'),
                    value: '0'
                }, {
                    text: this.$t('Individual'),
                    value: '1'
                }, {
                    text: this.$t('Corporate'),
                    value: '2'
                }],
      Filters: {
                    BaslangicCari: null,
                    BitisCari: null,
                    AnaHeseap: null,
                    HesapGrubu: [],
                    AnalizKodu: null,
                    Masraf: null,
                    CariTip: '0', //0:hepsi, 1 : bireysel, 2 : Kurumsal
                    HesapGrupBos: false,
                    MuhKodBos: false,
                    DisAktarimBos: false,
                    MasrafMerkeziTanimli: false,
                    TitleOne:null,
                    TitleTwo:null,
                    TcNo:null,
                    AliciSatici:0,
            },
      dialogItems:[],
      loadingResult:false,
      limitSearchText:null,
      dialog:false,
      counter: 0,
      dialogWarningNote:false,
      warningNote:null,
      hesapgurubu: [],
      rule: [],
      fav: true,
      menu: false,
      message: false,
      hints: true,
      bakiye: 0,
      vknmesaj: null,
      vkngorunum: false,
      efaturamukellefi: false,
      musteritipi: [
        {
          text: this.$t('Individual'),
          value: "B",
        },
        {
          text: this.$t('Corporate'),
          value: "K",
        },
      ],
      valid: true,
      valid2: true,
      Current: {
        CompanyCode: "",
        Code: null,
        Title: null,
        Phone1: "",
        CreditLimit1: 0,
        Phone2: "",
        Mobile: "",
        Web: "",
        Email: "",
        AccountGroup: "",
        AccountingCode: "",
        Type: "",
        CMCode: "",
        Reserved1: "",
        Reserved2: "",
        Authorized: "",
        WarningNote: "",
        InfoNote: "",
        CustomerType: "",
        TicketBill: "",
        EInvoiceType: "",
        PostCodeLabel: "",
        EInvoiceCustomer: "",
        MultiPostUse: false,
        EArchiveSendType: true,
        EArchiveSendPaper: false,
        CreditLimit: 0,
        CreditLimitCurrencyAmount: 0,
        CreditLimitCurrency: "",
        WebPassword: "",
        PinCode: "",
        MileCode: "",
        ExpiryDayDomestic: "",
        ExpiryTypeDomestic: "",
        ExpiryDayInt: "",
        ExpiryTypeInt: "",
        ExpiryDayGeneral: "",
        ExpiryTypeGeneral: "",
        DiscountGeneral: "",
        DiscountDom: "",
        DiscountInt: "",
        DiscountDomService: "",
        DiscountIntService: "",
        TaxFree: "",
        ExternalCurrentCode: "",
        ExternalAccountingCode: "",
        StreamCurrentCode: "",
        ArkmanStreamCode: "",
        ExpenseCenter: null,
        TemplateID: "",
        ProfileForced: "",
        EventIDForced: "",
        MainAccount: "",
        Coper: false,
        AliciSatici:0,
        Invoice: {
          Address: "",
          PostCode: "",
          Province: "",
          Country: "",
          TaxNumber: "",
          TaxOffice: "",
          IdentityNumber: "",
          PerFirstName: "",
          PerFamilyName: "",
          PerTitle: "",
          PerMiddleName: "",
          PerNameSuffix: "",
          NoPrint: "",
          CustomerPersonelNoInvoice: "",
          DeliveryAddress: "",
          DeliveryName: "",
        },
        Contract: {
          ContractNumber: "",
          ContractDate: "",
          PaymentType: "",
          BankAccountNumber: "",
          BankBranchOffice: "",
          InvoiceRowNumber: "",
          InvoicePassengerName: "E",
          InvoiceFlightNumber: "",
        },
      },
      dialogyenicari: false,
      kredilimiti: 0,
      unvan: null,
      codeSet: null,
      efaturatipigecici: null,
      statecari: [],
      itemCari: [],
      search1: null,
      loading: false,
      TempCariAra:"",

      Cari: {
        SirketKodu: "",
        CariDetay: [],
        Serbest: true,
        AlisSatis: false,
        FaturaSeri: "",
        FaturaNo: "",
        Update: false,
        FaturaTip: 0, // 0 : Satış faturası , 1 : Iade Faturası
        Evrak: {
          Evrakkod: "",
        },
        Cari: {
          Kod: "",
        },
        EFaturaBilgi: {
          Unvani: "",
          Unvani2: "",
          Adres1: "",
          Adres2: "",
          IlceSehir: "",
          Email: "",
          VergiDairesi: "",
          VergiNo: "",
          TcKimlikNo: "",
          Adi: "",
          Soyadi: "",
          TUnvani: "",
          DigerAdi: "",
          OnAdiEki: "",
        },
        Tarih: null,
        GibSeri: "",
        Vade: null,
        Referans: {
          Kod: "",
        },
        Masraf: {
          Code: "",
        },
        Aciklama: "",
        Doviz: {
          DovizKod: "",
        },
        Kur: 0,
        TevkivatKdv: 0,
        FaturaID: 0,
        CariAktarma: false,
        Tutarlar: {
          ToplamTutar: 0,
          Iskonto: 0,
          FaturaToplam: 0,
          Kdv: 0,
          TevkifatKdv: 0,
        },
        Efaturakayit: false,
        Earchiveakayit: false,
        Kagitfatura: false,
        EarsivBilgi: {
          GonderimSekli: "",
          InternetSatis: "",
          pWebAdresi: "",
          OdemeSekli: "",
          OdemeSekliAciklama: "",
          OdemeAraci: "",
          OdemeTarihi: "",
        },
        EFaturaShowID: {
          EFaturaID: null,
          EFaturaGuid: null,
          FaturaStatus: null,
          PdfID: null,
          DizaynID: null,
          XsltID: null,
        },
      },
      kodmesajı: null,
      progress: false,
      items: [],
      aranacakkelime: null,
      secilendeger: null,
      text1: null,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
    };
  },

  watch: {
   'counter': function () {
     if (this.counter == 1) {
         this.yenicarikaydet()
     }
   },
    val: function (kod) {
      if (kod != null) {
        this.cariislemler();
      }
      if (kod == undefined) {
        kod = null;
      }
    },
    search1(val) {
   
        this.TempCariAra=val;   
        setTimeout(() => {
            if (this.TempCariAra===val)
            {
                val && this.carigetir(val);
            }
        },600);
    },

    dialog(val2) {
      if (!val2) return;
      requestAnimationFrame(() => {
        this.$refs.ara.focus();
      });
    },
  },
};

function carigetir(v) {
  this.statecari = [];
  this.itemCari = [];
  var credentials = JSON.parse(window.localStorage.getItem("credentials"));

  if (v.length >= 0) {
    var query = {};

            if(this.searchLimit == true){
                this.loadingResult = true;
            }

            if (this.Coper == true) {
                query = {
                    q: unescape(v),
                    c: credentials.CoperSirketNo,
                    l: this.searchLimit,
                    Coper: true
                }
            } else {
                
                if (this.Coper == true) {
                   query = {
                     q: unescape(v),
                     c: credentials.CoperSirketNo,
                     l: this.searchLimit,
                     Coper: true,
                   };
                 } else {
                   query = {
                     q: unescape(v),
                     c: credentials.SirketKodu,
                     l: this.searchLimit,
                     Coper: false,
                   };
                 }


            }
 

    this.loading = true;

    setTimeout(() => {
      this.$http
        .post(auth.API_URL + "api/options/CurrentSearch", query, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
  
              if(this.searchLimit == false){

                for (var i = 0; i < response.body.length; i++) {
                    var yeniitems = {
                      id: response.body[i].id,
                      unvan1: response.body[i].unvan1,
                      unvan2: response.body[i].unvan2,
                      autoText:
                        response.body[i].unvan1 +
                        "-" +
                        response.body[i].unvan2 +
                        +"-" +
                        response.body[i].id +
                        "-" +
                        response.body[i].vergino +
                        "-" +
                        response.body[i].tckimlikno +
                        "-" + 
                        response.body[i].uyari,
                    };

                    this.statecari.push(yeniitems);
                  }
                }else{
                    this.dialogItems = response.body;
                    this.loadingResult = false;
                }
          },
          (response) => {
          if (response.status === 0) {
               this.text1 = 'Service Unavailable'
               this.snackbar = true
           } else {
               this.text1 = 'Service Unavailable'
               this.snackbar = true
           }
          }
        );
      this.loading = false;
    }, 1);
  } else {
    this.val = null;
  }
}


function cariGetirSearchDialog() {
    this.statecari = []
    if (this.searchLimit == true) {
        setTimeout(() => {

            var credentials = JSON.parse(window.localStorage.getItem('credentials'))

            var params = {}

            if (this.Coper == true) {
                params = {
                    q: unescape(this.limitSearchText),
                    c: credentials.CoperSirketNo,
                    l: this.searchLimit,
                    Coper: true
                }
            } else {
                if (this.Coper == false) {
                    params = {
                        q: unescape(this.limitSearchText),
                        c: credentials.SirketKodu,
                        l: this.searchLimit,
                        Coper: false
                    }
                } else {
                    params = {
                        q: unescape(this.limitSearchText),
                        l: this.searchLimit,
                        c: credentials.SirketKodu,
                    }
                }

            }

            this.loadingResult = true;
            params = {
                ...params,
                Filters: this.Filters
            }

            this.$http.post(auth.API_URL + 'api/options/CurrentSearchForDialog', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                if(this.searchLimit == false){

                     for (var i = 0; i < response.body.length; i++) {
                    var yeniitems = {
                        id: response.body[i].id,
                        unvan1: response.body[i].unvan1,
                        unvan2: response.body[i].unvan2,
                        autoText: response.body[i].unvan1 + "-" + response.body[i].unvan2 + "-" + response.body[i].id + "-" + response.body[i].vergino + "-" + response.body[i].tckimlikno
                    }
                    this.statecari.push(yeniitems)
                }

                }else{
                    this.dialogItems = response.body;
                    this.loadingResult = false;
                }
               
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })
        }, 750)
    }
}

function beforeMount() {
  // if (this.statecariyedek != 'undefined' && this.statecariyedek != null && this.statecariyedek != '') {
  //     this.statecari.push(this.statecariyedek[0])
  //     this.cariislemler();
  // }
   var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            this.PB=credentials.ParaBirimi;
  if (
    this.statecariyedek != "undefined" &&
    this.statecariyedek != null &&
    this.statecariyedek != ""
  ) {
    //this.statecari.push(this.statecariyedek[0])
    this.cariislemler();
  } else if (
    this.value != null &&
    this.value != "" &&
    this.value != "undefined"
  ) {
    this.cariislemler();
  }
  if (this.zorunlumu === true) {
    this.rule = [(v) => !!v || this.$t('Mandatory-section')];
  }
}
</script>

<style scoped>
.outer {
  position: relative;
  display: inline-block;
  margin: 0 10px;
  padding-top: inherit + 100px;
}

.inner {
  position: absolute;
  top: 104%;
  left: 50%;
  padding-block-start: 30px;
  padding-block-end: 10px;
}

.icorta {
  margin: 0px auto;
  height: 226px;
  color: #fff;
  position: absolute;
  left: 92%;
  top: 95%;
  margin-left: -110px;
  margin-top: -15px;
}

.rotate {
  -moz-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
  transform: translateX(-50%) translateY(-50%) rotate(-90deg);
}

.carihesapsearch {
  max-height: 32;
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: justify;
  border-bottom: 2px solid rgb(118, 118, 118);
}

.teksatir {
  display: contents;
}
</style>
